import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ArrowUpRight } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { OrderFlowStats } from "@/components/landing/OrderFlowStats";
import { OrderFlowExplorer } from "@/components/landing/OrderFlowExplorer";
import { HyperliquidLayer } from "@/components/landing/HyperliquidLayer";
import { GuestVsFree } from "@/components/landing/GuestVsFree";
import { Footer } from "@/components/landing/Footer";

export default function OrderFlow() {
  useSeo({ title: "Free Crypto Order Flow Terminal | Footprint, Tape, CVD | TradrQuant", description: "Free order flow terminal for BTC and ETH: footprint candles, Smart Tape, CVD, live ladder and a Hyperliquid whale layer, built on real executed trades.", path: "/order-flow" });
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="order-flow-page" className="min-h-screen bg-[#0A0A0A] text-[#ECEBE4]">
      <header className="border-b border-white/[0.07]">
        <div className="mx-auto flex h-14 max-w-[1400px] items-center justify-between px-6 md:px-12">
          <Link to="/" className="flex items-center gap-2.5"><img src="/tq-logo.png?v=3" alt="TradrQuant" className="h-[22px] w-auto" /><span data-testid="wordmark" className="tq-wordmark text-[#ECEBE4] text-[21px]">Tradr<span className="tq-q">Q</span>uant</span></Link>
          <Link to="/" data-testid="of-back-btn" className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-[#7D8390] hover:text-[#ECEBE4]"><ChevronLeft size={14} /> Home</Link>
        </div>
      </header>
      <section className="mx-auto max-w-[1400px] px-6 pb-16 pt-20 md:px-12 md:pt-28">
        <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#7D8390]">Free public terminal · BTC & ETH</p>
        <h1 className="mt-6 max-w-4xl font-display text-[2.5rem] font-semibold leading-[1] tracking-[-0.04em] sm:text-6xl">If you trade order flow, <span className="text-[#BACD1C]">this one's free.</span></h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-[#9DA3AE]">The same order flow terminal that ships with the full TradrQuant launch, open to the public early.</p>
        <a href="https://alpha.tradrquant.com/terminal" data-testid="of-page-cta" className="mt-10 inline-flex items-center gap-2 bg-[#BACD1C] px-7 py-4 font-mono text-[13px] uppercase tracking-[0.14em] text-black hover:bg-[#ECEBE4]">Open order flow terminal <ArrowUpRight size={17} /></a>
      </section>
      <OrderFlowStats />
      <OrderFlowExplorer />
      <HyperliquidLayer />
      <GuestVsFree />
      <Footer />
    </div>
  );
}
